import moment from 'moment'
import { createValidator, richTextMaxLength } from 'util/validation'
import { medicoesPanelValidator } from 'view/atendimentos/components/MedicoesPanel/validator'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { ObjetivoFormModel } from './ObjetivoForm'

export const objetivoValidator = (cidadao: CidadaoAtendimento, dataAtendimento: Instant) =>
  createValidator<ObjetivoFormModel>(
    {
      medicoes: medicoesPanelValidator,
      texto: [richTextMaxLength(4000)],
    },
    (values, error) => {
      if (cidadao.informarDum) {
        if (values?.dum && moment(values?.dum).isBefore(cidadao.dataNascimento) && !error.dum) {
          error.dum = 'Deve ser posterior à data de nascimento do cidadão'
        } else if (values?.dum && moment(values?.dum).isAfter(dataAtendimento) && !error.dum) {
          error.dum = 'Deve ser anterior à data do atendimento'
        }
      }
      return error
    }
  )
